import React from "react";
import { Icon } from "./Icon.jsx";

// Die Ruhewerte stehen hier, die Abweichung unter dem Zeiger steht als :hover-Regel
// an .erp-btn in tokens/base.css. Der Zeigerzustand ist deshalb kein React-Zustand
// mehr: Ein Kennzeichen, das aus mouseenter/mouseleave zusammengezählt wird, bleibt
// hängen, sobald eines der beiden ausfällt (app-web-devtools#87).
const BASE = {
  display: "inline-flex", alignItems: "center", gap: 7,
  padding: "0 12px",
  fontFamily: "inherit", fontSize: "var(--fs-12)", fontWeight: "var(--fw-semibold)",
  borderRadius: "var(--r-field)", cursor: "pointer", whiteSpace: "nowrap",
  filter: "var(--btn-hot-filter, none)",
  textDecoration: "var(--btn-hot-decoration, none)",
  transition: "background var(--dur-instant) ease, color var(--dur-instant) ease, border-color var(--dur-instant) ease",
};

// Die Höhe je Stufe kommt aus denselben Token wie beim Icon-Knopf, damit ein
// Textknopf und ein Icon-Knopf nebeneinander auf derselben Linie sitzen.
const SIZES = { sm: "var(--h-icon-button-sm)", md: "var(--h-button)", lg: "var(--h-icon-button-lg)" };

const VARIANTS = {
  primary: { background: "var(--ac-blue)", border: "1px solid var(--ac-blue)", color: "#fff" },
  secondary: { background: "var(--btn-hot-bg, var(--bg-chip))", border: "1px solid var(--line-b)", color: "var(--fg-2)" },
  outline: { background: "var(--btn-hot-bg, transparent)", border: "1px solid var(--btn-hot-border, var(--line-d))", color: "var(--btn-hot-fg, var(--fg-4))", fontWeight: "var(--fw-regular)" },
  quiet: { background: "var(--btn-hot-bg, transparent)", border: "none", color: "var(--btn-hot-fg, var(--fg-5))", fontWeight: "var(--fw-regular)" },
  link: { background: "none", border: "none", padding: 0, height: 22, color: "var(--ac-blue)", fontWeight: "var(--fw-medium)", gap: 6 },
  // Gebaut wie primary, nur in Rot: Sie gilt der einen zerstörenden Handlung im
  // Dialogfuß, wo neben ihr das stille „Abbrechen" steht. Ein Icon-Knopf ist an
  // dieser Stelle nicht die Form, und ein Löschknopf ohne Fläche sieht aus wie
  // jeder andere. --ac-red ist dasselbe Rot, das IconButton tone="danger" liest.
  danger: { background: "var(--ac-red)", border: "1px solid var(--ac-red)", color: "#fff" },
};

export function Button({ children, variant = "secondary", size = "md", icon, iconRight, disabled = false, onClick, title, type = "button", style = {} }) {
  const dis = { background: "var(--bg-field-off)", border: "1px solid var(--line-d)", color: "var(--fg-9)", cursor: "default", filter: "none" };
  const s = { ...BASE, height: SIZES[size] || SIZES.md, ...VARIANTS[variant], ...(disabled ? dis : null), ...style };
  const glyph = variant === "link" ? 12 : 14;
  return (
    <button type={type} title={title} disabled={disabled} onClick={disabled ? undefined : onClick}
      className="erp-btn" data-variant={variant} style={s}>
      {icon ? <Icon name={icon} size={glyph} /> : null}
      {children}
      {iconRight ? <Icon name={iconRight} size={glyph} /> : null}
    </button>
  );
}
